import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import reservationStore from "../store/reservationStore";
import api from "../utils/api_v2";
import LodingData from "../utils/LodingData";

import Bottom from "./Bottom";
import ConsultationReservationTop from "../components/ConsultationReservationTop";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as util from "../utils/util";
import { Checkbox, FormControlLabel, styled } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import JoinAgreePop from "./Join/JoinAgreePop";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import $ from 'jquery';


const Reservation = () => {
  const storeData: any = reservationStore();
  const [reservationPersons, setReservationPersons] = useState([]); // 예약 대상 인원
  const navigate = useNavigate();

  const [checked, setChecked] = React.useState([false, false, false, false, false, false]);

  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, event.target.checked, event.target.checked, event.target.checked, event.target.checked, event.target.checked]);
    $('#termsWarningIcon').css('display', 'none');
    $('#privateWarningIcon').css('display', 'none');
    $('#usePolicyWarningIcon').css('display', 'none');
    $('#collectWarningIcon').css('display', 'none');
    $('#thirdWarningIcon').css('display', 'none');
    $('#adsWarningIcon').css('display', 'none');
  };

  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([event.target.checked, checked[1], checked[2], checked[3], checked[4], checked[5]]);
    $('#termsWarningIcon').css('display', 'none');
  };

  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], event.target.checked, false, false, false, checked[5]]);
    $('#privateWarningIcon').css('display', 'none');
  };

  const handleChange4 = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(checked[0], checked[1], event.target.checked, checked[3], checked[4], checked[5]);
    setChecked([checked[0], checked[1], event.target.checked, checked[3], checked[4], checked[5]]);
    $('#collectWarningIcon').css('display', 'none');
  };

  const handleChange5 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], checked[2], event.target.checked, checked[4], checked[5]]);
    $('#thirdWarningIcon').css('display', 'none');
  };

  const handleChange6 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], checked[2], checked[3], event.target.checked, checked[5]]);
    $('#adsWarningIcon').css('display', 'none');
  };

  const handleChange7 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked([checked[0], checked[1], checked[2], checked[3], checked[4], event.target.checked]);
    $('#usePolicyWarningIcon').css('display', 'none');
  };

  useEffect(() => {
    // 예약 대상 인원 목록
    if (util.strNull(window.localStorage.userCusID) !== '') {
      LodingData(() => api.post('customer/api/v1/CU_003_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
        setReservationPersons(res.data.filter((v: any) => v.grade == '본인')); // 심리상담은 본인만
      }).catch(function (error: any) {
        console.log(error)
      }));
    }
  }, []);

  // 예약하기
  async function doReservation(person: any) {
    if (!(checked[0] && checked[1] && checked[2] && checked[3] && checked[5])) {
      alert('\n듀얼헬스케어 이용약관에 대한 동의 후,\n\n예약이 가능합니다.');
      if (!checked[0]) $('#termsWarningIcon').css('display', 'block');
      if (!checked[1]) $('#privateWarningIcon').css('display', 'block');
      if (!checked[2]) $('#collectWarningIcon').css('display', 'block');
      if (!checked[3]) $('#thirdWarningIcon').css('display', 'block');
      // if (!checked[4]) $('#adsWarningIcon').css('display', 'block');
      if (!checked[5]) $('#usePolicyWarningIcon').css('display', 'block');
    } else {
      try {
        const companyInfo = await getCompanyInfo(person['famId']);
        localStorage.setItem('FAM_INFO', JSON.stringify(person));
        localStorage.setItem('companyInfo', JSON.stringify(companyInfo));
        storeData.setReservationInfo('famId', person['famId']);
        storeData.setReservationInfo('companyId', person['companyId']);
        const check = true;
        // TODO:: 테스트 위해 그냥 넘김 처리 / 아래 주석 해제 필요
        // const check = await checkStressSurveyStatus(companyInfo, reservationPersons.filter(item => item['grade'] === '본인')[0]['famName']);
        if (check) navigate('/reservation/ConsultationReservationStep');
      } catch (e) {
        throw e;
      }
    }
  }

  // 예약하기 대상 인원 회사 정보
  async function getCompanyInfo(famId: string) {
    let companyInfo = {};
    await LodingData(() => api.get('customer/api/v2/families/' + encodeURIComponent(famId) + '/companies').then((res: any) => {
      companyInfo = res.data.data;
    }).catch(function (error: any) {
      console.log(error)
    }));
    return companyInfo;
  }

  // 직무 스트레스 조사 여부 확인
  function checkStressSurveyStatus(com: any, famName: string) {
    if (com['is_survey']) {
      if (!com['is_owner_has_stress_survey']) {
        //TODO:: 나중에 is_owner ? 직무 스트레스 페이지로 : 아무 동작 없음(가족이라서 직무 스트레스 참여X)
        if (com['is_owner']) {
          alert(famName + '(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.');
          navigate('/stress');
          return false;
          // if (window.confirm(famName + "(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.")) {
          //   navigate('/stress')
          //   return false;
          // }
        } else {
          alert(famName + '(본인) 회원님의\n직무 스트레스 조사가 완료된 후에\n예약 진행이 가능합니다.');
          return false;
        }
      }
    }
    return true;
  }



  return (


    <Container className="container">
      <ConsultationReservationTop />
      <Grid item>
        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
          <b>원하시는 검진 프로그램</b>을 <br /><b>편리하게 예약</b>하실 수 있습니다.
        </Typography>
      </Grid>

      {
        util.strNull(window.localStorage.userCusID) === ''
          ? null
          : (
            <Box sx={{ width: '100%', ml: 'auto', mr: 'auto', mt: 3 }}>
              <Container sx={Logbg}>
                <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>

                  <Stack direction={'row'} alignItems={'center'} sx={{ mt: 2, ml: 2, mr: 1 }}>
                    <FormControlLabel
                      label="전체 약관 동의"
                      control={
                        <Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />}
                          checked={checked[0] && checked[1] && checked[2] && checked[3] && checked[4] && checked[5]}
                          onChange={handleChange1}
                        />}
                      sx={checkBtn}
                    />
                  </Stack>

                  <Divider sx={{ mt: 1, mb: 1 }} />

                  <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}>
                    <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1 }}>
                      <FormControlLabel
                        label="서비스 이용약관(필수)"
                        control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[0]} onChange={handleChange2} />}
                        sx={checkBtn}
                      />
                      <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="termsWarningIcon" />
                      <JoinAgreePop type="terms" />
                    </Stack>

                    <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5 }}>
                      <FormControlLabel
                        label="개인정보 처리방침(필수)"
                        control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[1]} onChange={handleChange3} />}
                        sx={checkBtn}
                      />
                      <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="privateWarningIcon" />
                      <JoinAgreePop type="private" />
                    </Stack>

                    {
                      checked[1] == true
                        ? <>
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                            <FormControlLabel
                              label="개인(민감)정보 수집 및 이용 동의 (필수)"
                              control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[2]} onChange={handleChange4} />}
                              sx={checkBtn}
                            />
                            <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="collectWarningIcon" />
                            <JoinAgreePop type="collect" />
                          </Stack>
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                            <FormControlLabel
                              label="제3자 개인정보 제공 동의(건강검진 및 심리상담) (필수)"
                              control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[3]} onChange={handleChange5} />}
                              sx={checkBtn}
                            />
                            <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="thirdWarningIcon" />
                            <JoinAgreePop type="third" />
                          </Stack>
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5, ml: 4 }}>
                            <FormControlLabel
                              label="홍보 및 마케팅 수집·이용 동의서 (선택)"
                              control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[4]} onChange={handleChange6} />}
                              sx={checkBtn}
                            />
                            <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="adsWarningIcon" />
                            <JoinAgreePop type="ads" />
                          </Stack>
                        </>
                        : null
                    }

                    <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mr: 1, mt: .5 }}>
                      <FormControlLabel
                        label="건강검진 이용 및 취소/환불 규정 확인 (필수)"
                        control={<Checkbox icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} checked={checked[5]} onChange={handleChange7} />}
                        sx={checkBtn}
                      />
                      <WarningAmberIcon sx={{ color: 'red', display: 'none' }} id="usePolicyWarningIcon" />
                      <JoinAgreePop type="usePolicy" />
                    </Stack>
                  </Box>
                </Stack>
              </Container>
            </Box>
          )
      }

      {
        util.strNull(window.localStorage.userCusID) === ''
          ? (
            <Grid item sx={{ mt: 10 }}>
              <Box sx={BtnStyle}>
                <Button variant="contained" sx={BottomBtnStyle}
                  onClick={() => navigate('../Login')}
                >
                  로그인 후 이용해주세요.
                </Button>
              </Box>
            </Grid>
          )
          : (
            reservationPersons && reservationPersons.map((person, index) => (
              <Grid key={index} item sx={{ m: '30px auto', width: '80%' }}>
                <Card variant="outlined" sx={{ borderRadius: 5 }}>
                  <Box sx={{ p: 2 }}>
                    <Stack justifyContent="space-between" alignItems="center">
                      <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, color: '#777', }}>
                        예약자 정보 ({person['grade']})
                      </Typography>
                    </Stack>
                  </Box>
                  <Divider variant="middle" />
                  <Box sx={{}}>
                    <Stack direction="row" spacing={1}>
                      <List sx={{ pl: 3, width: '10%' }}>
                        <ListItem sx={{ pt: '12px', pb: '11px', pl: 1, pr: 1 }}>
                          성명
                        </ListItem>
                        <ListItem sx={{ pl: 1, pr: 1 }}>
                          생년월일
                        </ListItem>
                        <ListItem sx={{ pl: 1, pr: 1 }}>
                          연락처
                        </ListItem>
                        <ListItem sx={{ pl: 1, pr: 1 }}>
                          주소
                        </ListItem>
                      </List>
                      <List sx={{ width: '65%', }}>
                        <ListItem sx={{ pl: 0, pb: '11px', fontWeight: 700, color: '#0d6703', fontSize: 18 }}>
                          {person['famName']}
                        </ListItem>
                        <ListItem sx={{ pl: 0, fontWeight: 500, }}>
                          {person['birthDate']}
                        </ListItem>
                        <ListItem sx={{ pl: 0, fontWeight: 500, }}>
                          {person['phone']}
                        </ListItem>
                        <ListItem sx={{ pl: 0, fontWeight: 500, lineHeight: '180%' }}>
                          {person['address'] + ', ' + person['buildingNum']}
                        </ListItem>
                      </List>

                      <Box sx={BtnStyle}>
                        {!person['counselReserved'] ? (
                          <Button variant="contained" sx={BottomBtnStyle}
                            onClick={() => doReservation(person)}>
                            예약하기
                          </Button>
                        ) : (
                          <Button variant="contained" sx={BottomBtnOkStyle}
                            onClick={() => doReservation(person)}>
                            추가 상담 예약
                          </Button>
                        )}
                      </Box>
                    </Stack>


                  </Box>
                  <Divider variant="middle" />

                </Card>
              </Grid>
            )))
      }
      <Bottom />
    </Container>


  );
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  m: 3,
  p: 2,
  width: '25%'
};

const BottomBtnStyle = {
  width: '80%',
  hegiht: 60,
  bgcolor: '#0093ff',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #0093ff',
  ':hover': {
    backgroundColor: '#1771b3',
    borderColor: '#1771b3',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#0093ff',
    borderColor: '#0093ff',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const BottomBtnOkStyle = {
  width: '80%',
  hegiht: 60,
  bgcolor: '#0d6703',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  // border: '1px solid #0d6703',
  ':hover': {
    backgroundColor: '#074300',
    borderColor: '#074300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#0d6703',
    borderColor: '#0d6703',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const checkBtn = {
  '& .MuiCheckbox-root': { color: '#999' },
  '& .MuiCheckbox-root.Mui-checked': { color: '#0d6703' },
  '& .MuiFormControlLabel-label': { fontSize: 14 }
}

const Logbg = {
  bgcolor: '#fff',
  maxWidth: '80% !important',
  pb: 4,
  minWidth: '320px',
  width: '80%',
  borderRadius: '15px'
}

export default Reservation;